<template>
  <div class="countdown-container">
    <div class="wh100" >
      <img src="/static/images/countdownback.png" srcset="/static/images/countdownback@2x.png 2x"/>
      <div class="digits" layout="row center-spread">

        <countdown-digit label="TAGE" :value="timeSpan.days"/>
        <countdown-digit label="STUNDEN" :value="timeSpan.hours"/>
        <countdown-digit label="MINUTEN" :value="timeSpan.minutes"/>
        <countdown-digit label="SEKUNDEN" :value="timeSpan.seconds"/>
      </div>
    </div>
  </div>
</template>

<script>
  import CountdownDigit from "./CountdownDigit";
  import Countdown from '@/Countdown';

  export default {
    components: {CountdownDigit},
    name: "countdown",
    props:['date', 'startDate'],
    data() {
      return {
        timeSpan: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      }
    },
    created() {
      this.countdown = new Countdown();

    },
    methods: {
      updateDate() {
        this.countdown.start(this.startDate || Date.now(), this.date,
          span => {
            this.timeSpan = span;
          },
          () => {
            this.$emit('complete');
          });
      }
    },

    deactivated() {
        this.countdown.stop();
    },

    watch: {
      date: function(newVal, oldVal) {
        this.updateDate();
      }
    },
    activated() {
      this.updateDate();
    }
  }
</script>

<style lang="scss" scoped>
  .countdown-container {
    width: 100%;
    max-width: 900px;
    position: relative;
    /*background-color: yellow;*/
  }

  .countdown-container img {
    /*position: relative;*/
    width: 100%;
  }

  .digits {
    position: absolute;
    top: 5vw;
    left: 2vw;
    padding-left: 3vw;
    padding-right: 8vw;
    @media screen and (min-width: 1200px) {
      top:55px;
    }
    @media screen and (max-width: 800px) {
      top:4vw;
    }

    @media screen and (max-width: 600px) {
      top:5.5vw;
    }

    @media screen and (max-width: 360px) {
      top:25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/Countdown.vue